<div class="station-header">
    <div class="contiene-rotulo" [attr.data-isPanelView]='isPanelView'>
        <div class="rotulo">
            <h3 class="titulo"><b>{{currentView.name}}</b> | {{station.apiesText}} - {{station.name}}</h3>
        </div>
    </div>
</div>